import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Subject } from 'rxjs/Rx';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Alergia, HojaDeConsulta } from '../models/';

@Injectable()
export class MasterService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/maestros',
    });
  }

  /**
   * obtenerMasterAlergias: obtiene el listado completo de maestros de alergias
   * @param string: token
   * @return any
   */
  obtenerMasterEstadosAlergias(): any {
    return this._http.get('data/masteralergias.json')
      .map((res: Response) => {
        return res.json();
      });
  }
  /**
   * obtenerMasterTecnicasTerpeuticas: Obtiene el maestro de Tecnicas Terapéuticas
   * @param void
   * @return any
   */
  obtenerMasterTecnicasTerpeuticas(): any {
    return this._http.post(environment.api_host + 'maestros/tecnicasTerapeuticas', '').map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * obtenerMasterTecnicasDiagnosticas: Obtiene el maestro de Tecnicas Diagnosticas
   * @param void
   * @return any
   */
  obtenerMasterTecnicasDiagnosticas(): any {
    return this._http.post(environment.api_host + 'maestros/tecnicasDiagnosticas', undefined).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerMasterViasAdministración(idTecnica: string): any {
    return this._http.post(environment.api_host + 'maestros/viasAdministracion', { idTecnica: idTecnica }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerMasterDiagnosticos(nombre: string): any {
    let params: any = {
      nombre: nombre,
    };
    return this._http.post(environment.api_host + 'maestros/enfermedades', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerMasterDiagnosticosPorId(id: string): any {
    let params: any = {
      id: id,
    };
    return this._http.post(environment.api_host + 'maestros/enfermedadesPorId', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerPrincipiosActivos(nombre: string): any {
    let params: any = {
      nombre: nombre,
    };
    return this._http.post(environment.api_host + 'maestros/principiosActivos', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerMasterAlergias(): any {
    return this._http.post(environment.api_host + 'maestros/alergias', undefined).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
}



// WEBPACK FOOTER //
// ./src/services/master.service.ts